import classes from './RadKiosk.module.css';
import logo from "../../../store/radisson-blu-limerick-logo-white.png"
import meetlogo from "../../../store/radisson-meetings.png"
import RecordKiosk from "./RecordKiosk";
import {useEffect, useState} from "react";
import axios from "axios";
import {path} from "../../../routes";


const RadKiosk = (props) => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const [todayText, setTodayText] = useState("Radisson ")
    const [roomID, setroomID] = useState(props.roomId);
    const [object, setobject] = useState(Array.isArray(props.data) ? props.data : []);

    // Když rodič (MainJS) pošle nová data, zobrazit je hned
    useEffect(() => {
        if (Array.isArray(props.data) && props.data.length > 0) {
            setobject(props.data);
        }
    }, [props.data]);
    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }


    useEffect(() => {
        const resetVal = async () => {
            const rs = await axios.post(`${path}/updateReset/17`)
        }
        const getReset = async () =>{
            try {
                const response = await axios.get(`${path}/getReset/17`);
                //console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1)
                {
                    console.log("update")
                    resetVal()
                    window.location.reload();
                }
                else {
                    console.log("no update")
                }
            }
            catch (error){

            }
        }

        const send = async () => {
            try {
                const response = await axios.get(`${path}/getDayListV2?orgID=AC9D7FD5-E333-4B1E-9043-4697568313B7&&day=${getTime()}`);
                if (response.data.length > 0) {
                    setobject(response.data);
                } else {
                    props.jump(2);
                }
            } catch (error) {
                // Ponechat stávající data při chybě sítě
            }
        };
        send(); // první načtení hned po mountu
        const intervalId2 = setInterval(send, 60 * 1000); // pak každou minutu
        const intervalId3 = setInterval(getReset, 60 * 5 * 1000);

        //const hourDelay = 15 * 60 * 1000; // 1 hour in milliseconds
        //const refreshPage = setTimeout(() => {
        //   window.location.reload();
        //  }, hourDelay);

        const dt = new Date
        //SCHEDULE ON FRIDAY, AUGUST 30, 2024
        setTodayText(`SCHEDULE ON ${days[dt.getDay()].toUpperCase()}, ${months[dt.getMonth()].toUpperCase()} ${dt.getDate()}, ${dt.getFullYear()}`)
        return () => {
            // clearTimeout(refreshPage);
            clearInterval(intervalId2);
            clearInterval(intervalId3);
        };

    }, [])
    // Sloučit záznamy se shodným meetingem (text + dateFrom + dateTo).
    // Pokud spojené místnosti sdílí prefix (Authentic 1+2+3), zobrazí se
    // jako "Authentic 1 + 2 + 3". Smíšené prefixy zůstanou jako oddělené řádky.
    const mergedRecords = (() => {
        const list = Array.isArray(object) ? object : [];
        const groups = new Map();
        for (const rec of list) {
            const k = `${rec.text}__${rec.dateFrom}__${rec.dateTo}`;
            if (!groups.has(k)) groups.set(k, []);
            groups.get(k).push(rec);
        }
        const out = [];
        for (const recs of groups.values()) {
            if (recs.length === 1) { out.push(recs[0]); continue; }
            const splits = recs.map(r => {
                const name = String(r.room || '').trim();
                const m = name.match(/^(.*?)\s*(\S+)$/);
                return { rec: r, prefix: m ? m[1].trim() : name, suffix: m ? m[2] : '' };
            });
            const samePrefix = splits.every(s => s.prefix === splits[0].prefix) && splits[0].prefix !== '';
            if (!samePrefix) { for (const r of recs) out.push(r); continue; }
            const suffixesSorted = splits
                .map(s => s.suffix)
                .sort((a, b) => {
                    const na = parseFloat(a);
                    const nb = parseFloat(b);
                    if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;
                    return String(a).localeCompare(String(b));
                });
            out.push({
                ...recs[0],
                room: `${splits[0].prefix} ${suffixesSorted.join(' + ')}`
            });
        }
        return out;
    })();

    return <div className={classes.main}>
        <div className={classes.header}>
            <img src={logo} alt={"logo"}/>
        </div>
        <div className={classes.body}>
            <div className={classes.text}>{todayText}</div>
            <div className={classes.records}>
                {mergedRecords.map((x) => {
                    let timeFrom = x.dateFrom.substring(11, 16)
                    let timeTo = x.dateTo.substring(11, 16)
                    return <RecordKiosk key={x.id} path={x.path} text={x.text} room={x.room} pointer={x.pointer}
                                        timeslot={`${timeFrom} - ${timeTo}`}/>
                })}
            </div>
        </div>
        <div className={classes.footer}>
            <img src={meetlogo} alt={"logo"}/>
        </div>
    </div>
}
export default RadKiosk